import ContainerMetricasHomeSkeleton from "./styles";
import { useTheme } from "../../../contexts/Theme/ThemeContext";

interface SkeletonMetricasHomeProps {}

const SkeletonMetricasHome: React.FC<SkeletonMetricasHomeProps> = ({}) => {
  const { theme } = useTheme();

  return (
    <>
      <ContainerMetricasHomeSkeleton theme={theme}>
        {/* 4 cards de métricas da Home */}
        <div
          style={{ "--i": "0" } as React.CSSProperties}
          className="metricas-home-skeleton card-metrica"
        />
        <div
          style={{ "--i": "1" } as React.CSSProperties}
          className="metricas-home-skeleton card-metrica"
        />
        <div
          style={{ "--i": "2" } as React.CSSProperties}
          className="metricas-home-skeleton card-metrica"
        />
        <div
          style={{ "--i": "3" } as React.CSSProperties}
          className="metricas-home-skeleton card-metrica"
        />
      </ContainerMetricasHomeSkeleton>
    </>
  );
};

export default SkeletonMetricasHome;
